import React from 'react'
import { Link } from 'react-router'
import { prefixLink } from 'gatsby-helpers'
import { config } from 'config'

import 'normalize.css';
import '../css/main.scss';

class Template extends React.Component {
  render () {
    const { location, children } = this.props
    const header = (
      <header className='page-header container'>
        <h1 className='page-heading'>
          <Link to='/'>
            {config.blogTitle}
          </Link>
        </h1>
        <nav>
          <ul>
            <li><Link to='/'>Home</Link></li>
            <li><a href='https://www.instagram.com/sousvidediaries/'>Instagram</a></li>
          </ul>
        </nav>
      </header>
    )
    return (
      <div>
        {header}
        {children}
      </div>
    )
  }
}

Template.propTypes = {
  children: React.PropTypes.any,
  location: React.PropTypes.object,
  route: React.PropTypes.object,
}

export default Template



/** WEBPACK FOOTER **
 ** ./_template.js
 **/